import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { User } from '@angular/fire/auth';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, Observable } from 'rxjs';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import { AuthService } from '../../../core/auth/auth.service';
import { UserComponent } from '../user/user.component';

@Component({
  selector: 'app-auth',
  imports: [CommonModule, FontAwesomeModule, RouterModule, UserComponent],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent implements OnInit {

  //#region Font Awesome Icons
  iconUser = faUser;
  //#endregion

  //#region Properties
  continueUrl: string | null = null;

  user$: Observable<User | null>;
  //#endregion

  //#region Service Materials
  #auth: AuthService = inject(AuthService);

  #router: Router = inject(Router);
  //#endregion

  constructor() {
    this.user$ = this.#auth.user$.pipe(map((user: User | null) => !!user && !user.isAnonymous ? user : null));
  }

  //#region Lifecycle Hooks
  /**
   * Initializes the component by retrieving the continue URL from query parameters
   */
  ngOnInit(): void {
    this.#router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (!event.url.startsWith('/account'))
          this.continueUrl = event.urlAfterRedirects;
      });
  }
  //#endregion

  //#region Sign Methods
  /**
   * A method which signs out the user.
   */
  public onSignOut(): void {
    this.#auth.signOut();
  }
  //#endregion

}
